var render = function render(){var _vm=this,_c=_vm._self._c;return _c('page',{attrs:{"setup":_vm.setup}},[_c('container-layout',{attrs:{"showActiveIndex":false,"router":true},on:{"selectMainMenu":_vm.selectMainMenu},scopedSlots:_vm._u([{key:"aside",fn:function(){return [_c('model-list')]},proxy:true},{key:"main",fn:function(){return [_c('menu-right')]},proxy:true}])})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }